import React, {useContext, useState} from 'react'
import {SettingLayoutContext} from "../context/SettingLayoutContext"
import Filter from "../../../statics/assets/icons/filter.svg"
import LayoutTable from "./data-table/LayoutTable"
import LayoutFilter from "./filters/LayoutFilter"
import AddLayoutSetting from "./actions/AddLayoutSetting"

const SettingLayoutPage = () => {
    const SettingLayoutPageContext = useContext(SettingLayoutContext)

    const {
        loading,
        error,
        filters,
        listLayout,
        onChangeFilter
    } = SettingLayoutPageContext

    const [showFilters, toggleFilters] = useState(false)

    const _toggleShowFilter = () => {
        toggleFilters(!showFilters)
    }

    return (
        <div className='LeadPage PageDefault position-relative'>
            <div className="PageHeading">
                <h1 className="PageTitle">Quản lý layout</h1>
                <div className="d-flex align-items-center">
                    <div className={`Filter mr-3 ${showFilters && 'filtersOpen'}`}>
                        <label onClick={_toggleShowFilter}><Filter width={20} height={20}/>Bộ lọc</label>
                    </div>

                    <AddLayoutSetting/>
                </div>
            </div>

            {
                showFilters && <LayoutFilter filters={filters} onChangeFilter={onChangeFilter}/>
            }

            <div className="PageTable pb-0">
                <LayoutTable
                    loading={loading}
                    error={error}
                    listLayout={listLayout}
                />
            </div>
        </div>
    )
}

export default SettingLayoutPage
